"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ButtonBase = ({ children, to = '', onPress, screenName, params, ...props }) => {
    const linkBuilder = native_1.useLinkBuilder();
    let action;
    if (screenName) {
        const link = linkBuilder(screenName, params);
        if (link) {
            action = native_1.StackActions.push(screenName, params);
            to = link;
        }
    }
    const { onPress: onPressLink, ...linkProps } = native_1.useLinkProps({
        to,
        action,
    });
    const handleOnPress = (e) => {
        if (to)
            onPressLink(e);
        if (onPress)
            onPress(e);
    };
    if (to && !props.disabled)
        Object.assign(props, linkProps);
    return react_1.default.createElement(react_native_1.TouchableOpacity, { ...props, activeOpacity: 0.4, onPress: handleOnPress, accessibilityRole: 'button' }, children);
};
exports.default = ButtonBase;
